import { Select, type SelectProps } from '@mantine/core'
import { type FC } from 'react'

export interface SelectInputProps extends SelectProps {}

export const SelectInput: FC<SelectInputProps> = (props) => (
  <Select
    mb='xs'
    radius='md'
    searchable
    selectOnBlur
    {...props}
  />
)
